import authService from './auth.service';
import userService from './user.service';
import jobfeedService from './jobfeed.service';
import jobDetailService from './jobdetail.service';
import gladiatorService from './gladiator.service';
import calendarService from './calendar.service';
import mfaService from './mfa.service';
import surveyService from './survey.service';
import competitionService from './competition.service';
import mediaService from './media.service';
import profileService from './profile.service';
import unsubscribeService from './unsubscribe.service';
import subscriptionService from './subscription.service';
import tagService from './tag.service';
import recruiterService from './recruiter.service';
import interviewService from './interview.service';
import suggestionService from './suggestion.service';
import courseService from './course.service';
import pendingAssessmentService from './pendingAssessment.service';
import recommendationService from './recommendation.service';
import extService from './ext.service';

export {
  mediaService,
  authService,
  userService,
  jobfeedService,
  jobDetailService,
  gladiatorService,
  calendarService,
  mfaService,
  surveyService,
  competitionService,
  profileService,
  unsubscribeService,
  subscriptionService,
  tagService,
  recruiterService,
  interviewService,
  suggestionService,
  courseService,
  pendingAssessmentService,
  recommendationService,
  extService,
};
